import {
  Autocomplete, Box, Checkbox, FormControlLabel, Grid,
  IconButton, TextField, Tooltip, Typography, Accordion,
  AccordionSummary, AccordionDetails
} from '@mui/material'
import React, { useEffect, useState } from 'react'
import ToastMsg from '../../../../Components/ToastMsg/ToastMsg'
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { COMMON_STYLE } from '../../../../Utility/Constants';
import ShowComponents from '../../DoctorNotes/Common/ShowComponent';
import RestAPIService from '../../../../Utility/Services/RestAPIService';
import { Serviceurls } from '../../../../Utility/API/Serviceurls';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const UmaAnteriorSegment = React.forwardRef((props, ref) => {
  const [anterior, setAnterior] = useState({
    appointmentId: '',
    patientId: '',
    doctorId: '',
    clinicId: '',
    le_lids: '',
    le_anterior_chamber: '',
    le_sclera: '',
    le_pupil: '',
    le_cornea: '',
    le_iris: '',
    le_lens: '',
    le_conjuctiva: '',
    le_extra_ocular: '',
    re_lids: '',
    re_anterior_chamber: '',
    re_sclera: '',
    re_pupil: '',
    re_cornea: '',
    re_iris: '',
    re_extra_ocular: '',
    re_lens: '',
    re_conjuctiva: '',
    right_eye_check: false,
    left_eye_check: false,
    normal_check: false,
    le_lids_sugg: [],
    le_anterior_chamber_sugg: [],
    le_sclera_sugg: [],
    le_pupil_sugg: [],
    le_cornea_sugg: [],
    le_iris_sugg: [],
    le_lens_sugg: [],
    le_conjuctiva_sugg: [],
    le_extra_ocular_sugg: [],
    re_lids_sugg: [],
    re_anterior_chamber_sugg: [],
    re_sclera_sugg: [],
    re_pupil_sugg: [],
    re_cornea_sugg: [],
    re_iris_sugg: [],
    re_lens_sugg: [],
    re_conjuctiva_sugg: [],
    re_extra_ocular_sugg: [],
    anteriorComments: '',

    prev_le_lids: '',
    prev_le_anterior_chamber: '',
    prev_le_sclera: '',
    prev_le_pupil: '',
    prev_le_cornea: '',
    prev_le_iris: '',
    prev_le_lens: '',
    prev_le_conjuctiva: '',
    prev_le_extra_ocular: '',
    prev_re_lids: '',
    prev_re_anterior_chamber: '',
    prev_re_sclera: '',
    prev_re_pupil: '',
    prev_re_cornea: '',
    prev_re_iris: '',
    prev_re_extra_ocular: '',
    prev_re_lens: '',
    prev_re_conjuctiva: '',
    prev_anteriorComments: '',

    anteriorList: {},
    enableCopy: false,
    left_eye_data: '',
    right_eye_data: '',
    dupComments: ''
  })
  const [message, setMessage] = useState({
    isErrorMsgText: '',
    successMsgText: '',
    isErrorMsg: false,
    successMsg: false,
  })

  React.useImperativeHandle(ref, () => ({
    performAnteriorSegmentAction: () => {
      let leftEye = anterior.left_eye_data === '' ? '' : JSON.parse(anterior.left_eye_data)
      let rightEye = anterior.right_eye_data === '' ? '' : JSON.parse(anterior.right_eye_data)
      const leftEyeKeys = ["lids", "conjuctiva", "cornea", "extra_ocular", "iris", "lens", "pupil", "sclera"];
      const rightEyeKeys = ["lids", "conjuctiva", "cornea", "extra_ocular", "iris", "lens", "pupil", "sclera"];
      const hasChanges = leftEyeKeys.some(key => leftEye[key] !== anterior[`le_${key}`]) ||
        rightEyeKeys.some(key => rightEye[key] !== anterior[`re_${key}`]) || anterior.dupComments !== JSON.stringify(anterior.anteriorComments);

      if (hasChanges) {
        postAnteriorSegmentData()
      }
    }
  }))

  const errorMessage = (message) => {
    setMessage({
      ...message,
      isErrorMsg: true,
      isErrorMsgText: `${message} - ANTERIOR SEGMENT`,
    })
  }

  const successMessage = (message) => {
    setMessage({
      ...message,
      successMsg: true,
      successMsgText: `${message} - ANTERIOR SEGMENT`,
    })
  }

  const msgClose = () => {
    setMessage({
      ...message,
      isErrorMsg: false,
      isErrorMsgText: '',
      successMsg: false,
      successMsgText: ''
    })
  }

  const apicalls = async () => {
    await getAnteriorSegmentData()
    await getAnteriorSegmentSuggData()
    await getPrevAnteriorSegmentData()
  }

  useEffect(() => {
    if (anterior.anteriorList) {
      let copy = Object.keys(anterior.anteriorList)?.length > 0 ? true : false
      setAnterior((prev) => ({
        ...prev,
        enableCopy: copy
      }))
    }
  }, [anterior.anteriorList])

  useEffect(() => {
    const eyeKeys = ["lids", "conjuctiva", "cornea", "extra_ocular", "iris", "lens", "pupil", "sclera"];

    const hasChanges =
      eyeKeys.some(key => String(anterior?.[`le_${key}`] || '').trim() !== '') ||
      eyeKeys.some(key => String(anterior?.[`re_${key}`] || '').trim() !== '') ||
      (String(anterior?.anteriorComments || '').trim() !== '');

    props.setAccordionOpen(hasChanges);
  }, [anterior]);

  const getAnteriorSegmentData = async () => {
    try {
      const response = await RestAPIService.getAll(Serviceurls.NEW_DOC_NOTES_ANTERIOR_SEGMENT + '?appointment_id=' + props.props?.appointment_id + '&doctor_id=' + props?.props?.doctorID)
      if (response?.data?.status === 'success') {
        let anteriorData = Object.keys(response?.data?.data)?.length > 0 ? response?.data?.data : {}
        setAnterior((prev) => ({
          ...prev,
          anteriorComments: Object.keys(anteriorData)?.length > 0 ? anteriorData?.comments : '',
          dupComments: Object.keys(anteriorData)?.length > 0 ? JSON.stringify(anteriorData?.comments) : JSON.stringify(''),

          re_lids: Object.keys(anteriorData)?.length > 0 ? anteriorData?.right_eye?.lids : '',
          re_anterior_chamber: Object.keys(anteriorData)?.length > 0 ? anteriorData?.right_eye?.anterior_chamber : '',
          re_sclera: Object.keys(anteriorData)?.length > 0 ? anteriorData?.right_eye?.sclera : '',
          re_conjuctiva: Object.keys(anteriorData)?.length > 0 ? anteriorData?.right_eye?.conjuctiva : '',
          re_pupil: Object.keys(anteriorData)?.length > 0 ? anteriorData?.right_eye?.pupil : '',
          re_cornea: Object.keys(anteriorData)?.length > 0 ? anteriorData?.right_eye?.cornea : '',
          re_iris: Object.keys(anteriorData)?.length > 0 ? anteriorData?.right_eye?.iris : '',
          re_lens: Object.keys(anteriorData)?.length > 0 ? anteriorData?.right_eye?.lens : '',
          re_extra_ocular: Object.keys(anteriorData)?.length > 0 ? anteriorData?.right_eye?.extra_ocular : '',
          right_eye_data: Object.keys(anteriorData)?.length > 0 ? JSON.stringify(anteriorData?.right_eye) : '',

          le_lids: Object.keys(anteriorData)?.length > 0 ? anteriorData?.left_eye?.lids : '',
          le_anterior_chamber: Object.keys(anteriorData)?.length > 0 ? anteriorData?.left_eye?.anterior_chamber : '',
          le_sclera: Object.keys(anteriorData)?.length > 0 ? anteriorData?.left_eye?.sclera : '',
          le_conjuctiva: Object.keys(anteriorData)?.length > 0 ? anteriorData?.left_eye?.conjuctiva : '',
          le_pupil: Object.keys(anteriorData)?.length > 0 ? anteriorData?.left_eye?.pupil : '',
          le_cornea: Object.keys(anteriorData)?.length > 0 ? anteriorData?.left_eye?.cornea : '',
          le_iris: Object.keys(anteriorData)?.length > 0 ? anteriorData?.left_eye?.iris : '',
          le_lens: Object.keys(anteriorData)?.length > 0 ? anteriorData?.left_eye?.lens : '',
          le_extra_ocular: Object.keys(anteriorData)?.length > 0 ? anteriorData?.left_eye?.extra_ocular : '',
          left_eye_data: Object.keys(anteriorData)?.length > 0 ? JSON.stringify(anteriorData?.left_eye) : ''
        }))
      }
    } catch (error) {
      if (error?.response?.data?.message) {
        errorMessage(error.response.data.message)
      } else {
        errorMessage(error.message)
      }
    }
  }

  const groupAndSeparateData = (data) => {
    return data.reduce((result, current) => {
      const unwantedFields = ["id", "created_by", "created_date", "modified_by", "modified_date", "appointment_id", "patient_id", "doctor_id", "comments", "eye_type"];
      Object.keys(current).forEach(key => {
        if (unwantedFields.includes(key)) return;
        if (!result[current.eye_type]) {
          result[current.eye_type] = {};
        }
        if (!result[current.eye_type][key]) {
          result[current.eye_type][key] = [];
        }
        if (!result[current.eye_type][key].includes(current[key])) {
          result[current.eye_type][key].push(current[key]);
        }
      });
      return result;
    }, { LE: {}, RE: {} })
  };

  const getAnteriorSegmentSuggData = async () => {
    try {
      const response = await RestAPIService.getAll(Serviceurls.NEW_DOC_NOTES_ANTERIOR_SEGMENT_SUGG + '?doctor_id=' + props?.props?.doctorID)
      if (response?.data?.status === 'success') {
        let suggData = response?.data?.data
        const uniqueAttributes = groupAndSeparateData(suggData);
        setAnterior((prev) => ({
          ...prev,
          le_lids_sugg: uniqueAttributes?.LE?.lids,
          le_anterior_chamber_sugg: uniqueAttributes?.LE?.anterior_chamber,
          le_conjuctiva_sugg: uniqueAttributes?.LE?.conjuctiva,
          le_cornea_sugg: uniqueAttributes?.LE?.cornea,
          le_extra_ocular_sugg: uniqueAttributes?.LE?.extra_ocular,
          le_iris_sugg: uniqueAttributes?.LE?.iris,
          le_lens_sugg: uniqueAttributes?.LE?.lens,
          le_sclera_sugg: uniqueAttributes?.LE?.sclera,
          le_pupil_sugg: uniqueAttributes?.LE?.pupil,

          re_lids_sugg: uniqueAttributes?.RE?.lids,
          re_anterior_chamber_sugg: uniqueAttributes?.RE?.anterior_chamber,
          re_conjuctiva_sugg: uniqueAttributes?.RE?.conjuctiva,
          re_cornea_sugg: uniqueAttributes?.RE?.cornea,
          re_extra_ocular_sugg: uniqueAttributes?.RE?.extra_ocular,
          re_iris_sugg: uniqueAttributes?.RE?.iris,
          re_lens_sugg: uniqueAttributes?.RE?.lens,
          re_sclera_sugg: uniqueAttributes?.RE?.sclera,
          re_pupil_sugg: uniqueAttributes?.RE?.pupil,
        }))
      }
    } catch (error) {
      if (error?.response?.data?.message) {
        errorMessage(error.response.data.message)
      } else {
        errorMessage(error.message)
      }
    }
  }

  const getPrevAnteriorSegmentData = async () => {
    try {
      const response = await RestAPIService.getAll(Serviceurls.NEW_DOC_NOTES_ANTERIOR_SEGMENT_COPY +
        '?appointment_id=' + props?.props?.appointment_id + '&patient_id=' + props?.props?.patient_id + '&doctor_id=' + props?.props?.doctorID
      )

      if (response?.data?.status === 'success') {
        let anteriorData = Object.keys(response?.data?.data)?.length > 0 ? response?.data?.data : {}
        setAnterior((prev) => ({
          ...prev,
          prev_anteriorComments: Object.keys(anteriorData)?.length > 0 ? anteriorData?.comments : '',

          prev_re_lids: Object.keys(anteriorData)?.length > 0 ? anteriorData?.right_eye?.lids : '',
          prev_re_anterior_chamber: Object.keys(anteriorData)?.length > 0 ? anteriorData?.right_eye?.anterior_chamber : '',
          prev_re_sclera: Object.keys(anteriorData)?.length > 0 ? anteriorData?.right_eye?.sclera : '',
          prev_re_conjuctiva: Object.keys(anteriorData)?.length > 0 ? anteriorData?.right_eye?.conjuctiva : '',
          prev_re_pupil: Object.keys(anteriorData)?.length > 0 ? anteriorData?.right_eye?.pupil : '',
          prev_re_cornea: Object.keys(anteriorData)?.length > 0 ? anteriorData?.right_eye?.cornea : '',
          prev_re_iris: Object.keys(anteriorData)?.length > 0 ? anteriorData?.right_eye?.iris : '',
          prev_re_lens: Object.keys(anteriorData)?.length > 0 ? anteriorData?.right_eye?.lens : '',
          prev_re_extra_ocular: Object.keys(anteriorData)?.length > 0 ? anteriorData?.right_eye?.extra_ocular : '',

          prev_le_lids: Object.keys(anteriorData)?.length > 0 ? anteriorData?.left_eye?.lids : '',
          prev_le_anterior_chamber: Object.keys(anteriorData)?.length > 0 ? anteriorData?.left_eye?.anterior_chamber : '',
          prev_le_sclera: Object.keys(anteriorData)?.length > 0 ? anteriorData?.left_eye?.sclera : '',
          prev_le_conjuctiva: Object.keys(anteriorData)?.length > 0 ? anteriorData?.left_eye?.conjuctiva : '',
          prev_le_pupil: Object.keys(anteriorData)?.length > 0 ? anteriorData?.left_eye?.pupil : '',
          prev_le_cornea: Object.keys(anteriorData)?.length > 0 ? anteriorData?.left_eye?.cornea : '',
          prev_le_iris: Object.keys(anteriorData)?.length > 0 ? anteriorData?.left_eye?.iris : '',
          prev_le_lens: Object.keys(anteriorData)?.length > 0 ? anteriorData?.left_eye?.lens : '',
          prev_le_extra_ocular: Object.keys(anteriorData)?.length > 0 ? anteriorData?.left_eye?.extra_ocular : '',

          anteriorList: Object.keys(anteriorData)?.length > 0 ? anteriorData : {}
        }))
      }
    } catch (error) {
      if (error?.response?.data?.message) {
        errorMessage(error.response.data.message)
      } else {
        errorMessage(error.message)
      }
    }
  }

  const postAnteriorSegmentData = async () => {
    try {
      let data = {
        appointment_id: props?.props?.appointment_id,
        comments: anterior.anteriorComments,
        right_eye: {
          eye_type: "RE",
          lids: anterior.re_lids ? anterior.re_lids : '',
          anterior_chamber: anterior.re_anterior_chamber ? anterior.re_anterior_chamber : '',
          sclera: anterior.re_sclera ? anterior.re_sclera : '',
          conjuctiva: anterior.re_conjuctiva ? anterior.re_conjuctiva : '',
          pupil: anterior.re_pupil ? anterior.re_pupil : '',
          cornea: anterior.re_cornea ? anterior.re_cornea : '',
          iris: anterior.re_iris ? anterior.re_iris : '',
          lens: anterior.re_lens ? anterior.re_lens : '',
          extra_ocular: anterior.re_extra_ocular ? anterior.re_extra_ocular : ''
        },
        left_eye: {
          eye_type: "LE",
          lids: anterior.le_lids ? anterior.le_lids : '',
          anterior_chamber: anterior.le_anterior_chamber ? anterior.le_anterior_chamber : '',
          sclera: anterior.le_sclera ? anterior.le_sclera : '',
          conjuctiva: anterior.le_conjuctiva ? anterior.le_conjuctiva : '',
          pupil: anterior.le_pupil ? anterior.le_pupil : '',
          cornea: anterior.le_cornea ? anterior.le_cornea : '',
          iris: anterior.le_iris ? anterior.le_iris : '',
          lens: anterior.le_lens ? anterior.le_lens : '',
          extra_ocular: anterior.le_extra_ocular ? anterior.le_extra_ocular : ''
        }
      }
      const response = await RestAPIService.create(data, Serviceurls.NEW_DOC_NOTES_ANTERIOR_SEGMENT)
      if (response?.data?.status === 'success') {
        successMessage(response?.data?.message)
        await getAnteriorSegmentData()
        await getAnteriorSegmentSuggData()
      }
    } catch (error) {
      if (error?.response?.data?.message) {
        errorMessage(error.response.data.message)
      } else {
        errorMessage(error.message)
      }
    }
  }

  const autocompleteTextbox = (names, values, label, options = []) => {
    try {
      return (
        <Autocomplete
          disabled={props?.props?.patient_transfered || props?.props?.isLocked}
          clearIcon
          freeSolo
          size='small'
          sx={{ width: '13.5dvw' }}
          value={values}
          options={options}
          getOptionLabel={(option) => typeof (option) === 'string' ? option : option[label]}
          onChange={(e, newValue) => {
            setAnterior((prev) => ({ ...prev, [names]: newValue }))
          }}
          onInputChange={(e, newValue) => {
            setAnterior((prev) => ({ ...prev, [names]: newValue }))
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              placeholder={'Type Remarks'}
              InputProps={{
                ...params.InputProps, emed_tid: names,
                style: { height: COMMON_STYLE.HEIGHT, padding: COMMON_STYLE.PADDING }
              }}
            />
          )}
        />
      )
    } catch (error) {
      errorMessage(error.message)
    }
  }

  const onChangeCheckBox = (e, key) => {
    try {
      let checked = e.target.checked
      const updateEyeState = (eye) => ({
        [`${eye}_lids`]: checked ? "Normal" : '',
        [`${eye}_conjuctiva`]: checked ? "Normal" : '',
        [`${eye}_sclera`]: checked ? "Normal" : '',
        [`${eye}_cornea`]: checked ? "Clear" : '',
        [`${eye}_anterior_chamber`]: checked ? "Normal Depth" : '',
        [`${eye}_pupil`]: checked ? "Normal Size reacting to light" : '',
        [`${eye}_iris`]: checked ? "Normal Color & Pattern" : '',
        [`${eye}_lens`]: checked ? "Clear" : '',
        [`${eye}_extra_ocular`]: checked ? "Normal" : '',
      });
      setAnterior((prev) => {
        switch (key) {
          case 'right_eye_check':
            return {
              ...prev,
              right_eye_check: checked,
              normal_check: prev.left_eye_check && checked,
              ...updateEyeState('re')
            };
          case 'left_eye_check':
            return {
              ...prev,
              left_eye_check: checked,
              normal_check: prev.right_eye_check && checked,
              ...updateEyeState('le')
            };
          case 'normal_check':
            return {
              ...prev,
              normal_check: checked,
              left_eye_check: checked,
              right_eye_check: checked,
              ...updateEyeState('le'),
              ...updateEyeState('re')
            };
          default:
            return prev;
        }
      });
    } catch (error) {
      errorMessage(error.message)
    }
  }

  return (
    <ShowComponents onIntersection={apicalls}>
      <Box component={'div'}>
        <Accordion expanded={props.accordionOpen}
          onChange={(_, isExpanded) => {
            props.setAccordionOpen(isExpanded, true);
          }}>
          <AccordionSummary className='doc_notes_header_card' expandIcon={<ExpandMoreIcon />}>
          <Box component={'div'} className='doc_notes_header_card' display={'flex'} justifyContent={'space-between'} alignItems={'center'} width={"100%"}>
            <Box component={'div'} display={'flex'} alignItems={'center'}>
              <Typography className='doc_notes_header_card_font'>Anterior Segment</Typography>
              <Tooltip placement='top' arrow title={'Copy'}><IconButton className='Common_Btn_Min_Width' emed_tid='ant_Seg_cpy'
                disabled={!anterior.enableCopy || props?.props?.patient_transfered || props?.props?.isLocked}
                onClick={() => {
                  setAnterior((prev) => ({
                    ...prev,
                    le_lids: anterior.prev_le_lids,
                    le_anterior_chamber: anterior.prev_le_anterior_chamber,
                    le_sclera: anterior.prev_le_sclera,
                    le_pupil: anterior.prev_le_pupil,
                    le_cornea: anterior.prev_le_cornea,
                    le_iris: anterior.prev_le_iris,
                    le_lens: anterior.prev_le_lens,
                    le_conjuctiva: anterior.prev_le_conjuctiva,
                    le_extra_ocular: anterior.prev_le_extra_ocular,
                    re_lids: anterior.prev_re_lids,
                    re_anterior_chamber: anterior.prev_re_anterior_chamber,
                    re_sclera: anterior.prev_re_sclera,
                    re_pupil: anterior.prev_re_pupil,
                    re_cornea: anterior.prev_re_cornea,
                    re_iris: anterior.prev_re_iris,
                    re_extra_ocular: anterior.prev_re_extra_ocular,
                    re_lens: anterior.prev_re_lens,
                    re_conjuctiva: anterior.prev_re_conjuctiva,
                    anteriorComments: anterior.prev_anteriorComments
                  }))
                }}
              ><ContentCopyIcon color={!anterior.enableCopy ? '' : 'primary'} /></IconButton></Tooltip>
            </Box>
            <Box component={'div'}>
              <FormControlLabel control={<Checkbox size='small' disabled={props?.props?.patient_transfered || props?.props?.isLocked} checked={anterior.right_eye_check} onChange={(e) => onChangeCheckBox(e, 'right_eye_check')} />} label="Right Eye" />
              <FormControlLabel control={<Checkbox size='small' disabled={props?.props?.patient_transfered || props?.props?.isLocked} checked={anterior.left_eye_check} onChange={(e) => onChangeCheckBox(e, 'left_eye_check')} />} label="Left Eye" />
              <FormControlLabel control={<Checkbox size='small' disabled={props?.props?.patient_transfered || props?.props?.isLocked} checked={anterior.normal_check} onChange={(e) => onChangeCheckBox(e, 'normal_check')} />} label="Normal" />
            </Box>
          </Box>
          </AccordionSummary>
          <AccordionDetails component={'div'} m={'0.5rem'}>
            <Box component={'div'}>
              <Grid container sx={{ display: 'flex', alignItems: 'center' }}>
                <Grid xs={3}><Typography className='doc_notes_header_card_font'></Typography></Grid>
                <Grid xs={4.5}><Typography className='doc_notes_header_card_font'>Right Eye</Typography></Grid>
                <Grid xs={4.5}><Typography className='doc_notes_header_card_font'>Left Eye</Typography></Grid>
              </Grid>
              <Grid container sx={{ display: 'flex', alignItems: 'center', mt: '0.8rem' }}>
                <Grid xs={3}><Typography className='doc_notes_header_card_font'>Lids</Typography></Grid>
                <Grid xs={4.5}>{autocompleteTextbox('re_lids', anterior.re_lids, 'label', anterior.re_lids_sugg)}</Grid>
                <Grid xs={4.5}>{autocompleteTextbox('le_lids', anterior.le_lids, 'label', anterior.le_lids_sugg)} </Grid>
              </Grid>
              <Grid container sx={{ display: 'flex', alignItems: 'center', mt: '0.8rem' }}>
                <Grid xs={3}><Typography className='doc_notes_header_card_font'>EOM</Typography></Grid>
                <Grid xs={4.5}>{autocompleteTextbox('re_extra_ocular', anterior.re_extra_ocular, 'label', anterior.re_extra_ocular_sugg)}</Grid>
                <Grid xs={4.5}>{autocompleteTextbox('le_extra_ocular', anterior.le_extra_ocular, 'label', anterior.le_extra_ocular_sugg)} </Grid>
              </Grid>
              <Grid container sx={{ display: 'flex', alignItems: 'center', mt: '0.8rem' }}>
                <Grid xs={3}><Typography className='doc_notes_header_card_font'>Conjunctiva</Typography></Grid>
                <Grid xs={4.5}>{autocompleteTextbox('re_conjuctiva', anterior.re_conjuctiva, 'label', anterior.re_conjuctiva_sugg)}</Grid>
                <Grid xs={4.5}>{autocompleteTextbox('le_conjuctiva', anterior.le_conjuctiva, 'label', anterior.le_conjuctiva_sugg)} </Grid>
              </Grid>
              <Grid container sx={{ display: 'flex', alignItems: 'center', mt: '0.8rem' }}>
                <Grid xs={3}><Typography className='doc_notes_header_card_font'>Sclera</Typography></Grid>
                <Grid xs={4.5}>{autocompleteTextbox('re_sclera', anterior.re_sclera, 'label', anterior.re_sclera_sugg)}</Grid>
                <Grid xs={4.5}>{autocompleteTextbox('le_sclera', anterior.le_sclera, 'label', anterior.le_sclera_sugg)} </Grid>
              </Grid>
              <Grid container sx={{ display: 'flex', alignItems: 'center', mt: '0.8rem' }}>
                <Grid xs={3}><Typography className='doc_notes_header_card_font'>Cornea</Typography></Grid>
                <Grid xs={4.5}>{autocompleteTextbox('re_cornea', anterior.re_cornea, 'label', anterior.re_cornea_sugg)}</Grid>
                <Grid xs={4.5}>{autocompleteTextbox('le_cornea', anterior.le_cornea, 'label', anterior.le_cornea_sugg)} </Grid>
              </Grid>
              <Grid container sx={{ display: 'flex', alignItems: 'center', mt: '0.8rem' }}>
                <Grid xs={3}><Typography className='doc_notes_header_card_font'>Anterior Chamber</Typography></Grid>
                <Grid xs={4.5}>{autocompleteTextbox('re_anterior_chamber', anterior.re_anterior_chamber, 'label', anterior.re_anterior_chamber_sugg)}</Grid>
                <Grid xs={4.5}>{autocompleteTextbox('le_anterior_chamber', anterior.le_anterior_chamber, 'label', anterior.le_anterior_chamber_sugg)} </Grid>
              </Grid>
              <Grid container sx={{ display: 'flex', alignItems: 'center', mt: '0.8rem' }}>
                <Grid xs={3}><Typography className='doc_notes_header_card_font'>Pupil</Typography></Grid>
                <Grid xs={4.5}>{autocompleteTextbox('re_pupil', anterior.re_pupil, 'label', anterior.re_pupil_sugg)}</Grid>
                <Grid xs={4.5}>{autocompleteTextbox('le_pupil', anterior.le_pupil, 'label', anterior.le_pupil_sugg)} </Grid>
              </Grid>
              <Grid container sx={{ display: 'flex', alignItems: 'center', mt: '0.8rem' }}>
                <Grid xs={3}><Typography className='doc_notes_header_card_font'>Iris</Typography></Grid>
                <Grid xs={4.5}>{autocompleteTextbox('re_iris', anterior.re_iris, 'label', anterior.re_iris_sugg)}</Grid>
                <Grid xs={4.5}>{autocompleteTextbox('le_iris', anterior.le_iris, 'label', anterior.le_iris_sugg)} </Grid>
              </Grid>
              <Grid container sx={{ display: 'flex', alignItems: 'center', mt: '0.8rem' }}>
                <Grid xs={3}><Typography className='doc_notes_header_card_font'>Lens</Typography></Grid>
                <Grid xs={4.5}>{autocompleteTextbox('re_lens', anterior.re_lens, 'label', anterior.re_lens_sugg)}</Grid>
                <Grid xs={4.5}>{autocompleteTextbox('le_lens', anterior.le_lens, 'label', anterior.le_lens_sugg)} </Grid>
              </Grid>
            </Box>
            <Box component={'div'} mt={'0.5rem'}>
              <TextField
                disabled={props?.props?.patient_transfered || props?.props?.isLocked}
                size='small'
                multiline
                fullWidth
                maxRows={5}
                value={anterior.anteriorComments}
                onChange={(e) => {
                  let value = e.target.value
                  if (value?.length <= COMMON_STYLE.CHAR_LIMIT_DESP)
                    setAnterior({ ...anterior, anteriorComments: value })
                }}
                placeholder='Comments'
                InputProps={{ emed_tid: 'ant_seg_cmts' }}
              />
            </Box>
          </AccordionDetails>
        </Accordion>
        {message.isErrorMsg ?
          <ToastMsg
            severity={'error'}
            msg={message.isErrorMsgText}
            msgPop={msgClose}
          />
          : null}
        {message.successMsg ?
          <ToastMsg
            severity={'success'}
            msg={message.successMsgText}
            msgPop={msgClose}
          />
          : null}
      </Box>
    </ShowComponents>
  )
})

export default UmaAnteriorSegment